import { render } from "./TopInvestorsChart.vue?vue&type=template&id=6d6027a8&scoped=true"
import script from "./TopInvestorsChart.vue?vue&type=script&lang=js"
export * from "./TopInvestorsChart.vue?vue&type=script&lang=js"

import "./TopInvestorsChart.vue?vue&type=style&index=0&id=6d6027a8&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6027a8"]])

export default __exports__